const COLORS = {
    label: '#677b8b',
};

export default COLORS;
